'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _express2 = _interopRequireDefault(_express);

var _minimajs = require('minimajs');

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticRoute = function () {
    /**
     * StaticRoute
     *
     * @param {Minima} minima
     * @param {Express} app
     * @memberof IndexRoute
     */
    function StaticRoute(minima, app) {
        (0, _classCallCheck3.default)(this, StaticRoute);

        this.minima = minima;
        this.app = app;
        this.createRoute = this.createRoute.bind(this);
        this.addStatic = this.addStatic.bind(this);
        this.removeStatic = this.removeStatic.bind(this);
        this.pluginStateChangedListener = this.pluginStateChangedListener.bind(this);

        this.createRoute();
        this.minima.addPluginStateChangedListener(this.pluginStateChangedListener);
    }

    (0, _createClass3.default)(StaticRoute, [{
        key: 'createRoute',
        value: function createRoute() {
            this.app.use('/static', _express2.default.static(_path2.default.resolve('./static')));
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.minima.getPlugins()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pair = _step.value;

                    var plugin = pair[1];
                    this.addStatic(plugin);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'addStatic',
        value: function addStatic(plugin) {
            this.app.use('/plugins/' + plugin.id + '/controllers', _express2.default.static(_path2.default.join(plugin.pluginDirectory, 'controllers')));
            this.app.use('/plugins/' + plugin.id + '/utilities', _express2.default.static(_path2.default.join(plugin.pluginDirectory, 'utilities')));
            this.app.use('/plugins/' + plugin.id + '/views', _express2.default.static(_path2.default.join(plugin.pluginDirectory, 'utilities')));
        }
    }, {
        key: 'removeStatic',
        value: function removeStatic(plugin) {
            // TODO: remove the static
        }
    }, {
        key: 'pluginStateChangedListener',
        value: function pluginStateChangedListener(id, previous, current) {
            var plugin = this.minima.getPlugin(id);
            if (current === _minimajs.PluginState.ACTIVE) {
                this.addStatic(plugin);
            } else if (previous === _minimajs.PluginState.STOPPING && current === _minimajs.PluginState.RESOLVED) {
                this.removeStatic(plugin);
            }
        }
    }]);
    return StaticRoute;
}();

exports.default = StaticRoute;
//# sourceMappingURL=StaticRoute.js.map